import React from 'react'

import { Monitor, Storage } from '@mui/icons-material'
import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@mui/material'

import metadata from '~/../package.json'
import useStoreState from '~/hooks/useStoreState'

const Version = () => {
  const { backend_version } = useStoreState('config')

  return (
    <Box
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <List sx={{ scale: '2' }}>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <Monitor />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Frontend" secondary={metadata.version} />
        </ListItem>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <Storage />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Backend" secondary={backend_version} />
        </ListItem>
      </List>
    </Box>
  )
}

export default Version
